// Client-side notification translation map (PT → DE)
const titleMap: Record<string, string> = {
  "✅ Contrato totalmente assinado!": "✅ Vertrag vollständig unterschrieben!",
  "✍️ Contrato assinado pelo Admin": "✍️ Vertrag vom Admin unterschrieben",
  "📝 Contrato pronto para assinatura": "📝 Vertrag bereit zur Unterschrift",
  "✅ Contrato aprovado!": "✅ Vertrag genehmigt!",
  "🔐 Contas configuradas!": "🔐 Konten konfiguriert!",
  "🚀 Postagens 100% ativas!": "🚀 Beiträge 100% aktiv!",
  "📱 Postagens Maloum ativas!": "📱 Maloum-Beiträge aktiv!",
  "📱 Postagens 4Based ativas!": "📱 4Based-Beiträge aktiv!",
  "🎉 Parabéns pela primeira venda!": "🎉 Herzlichen Glückwunsch zum ersten Verkauf!",
  "💬 Nova mensagem recebida": "💬 Neue Nachricht erhalten",
  "💬 Nova Mensagem Recebida": "💬 Neue Nachricht erhalten",
  "📸 Novo pedido de conteúdo exclusivo": "📸 Neue exklusive Inhaltsanfrage",
  "📋 Novo pedido de conteúdo para aprovação": "📋 Neuer Inhalt zur Genehmigung",
  "📸 Conteúdo exclusivo entregue": "📸 Exklusiver Inhalt geliefert",
  "📋 Neue Aufgabe zugewiesen": "📋 Neue Aufgabe zugewiesen",
  "⏰ Meeting-Erinnerung": "⏰ Meeting-Erinnerung",
  "🔗 Neue Model-Verbindung": "🔗 Neue Model-Verbindung",
  "📅 Lembrete de conteúdo": "📅 Inhaltserinnerung",
  "📅 Content-Erinnerung": "📅 Content-Erinnerung",
  "⚠️ Multa aplicada por atraso": "⚠️ Strafe wegen Verspätung",
  "⚠️ Multa aplicada": "⚠️ Strafe angewendet",
  "📅 Postagens precisam de agendamento": "📅 Beiträge müssen geplant werden",
  "🆕 Novo modelo registrado": "🆕 Neues Model registriert",
  "📋 Nova solicitação de cadastro": "📋 Neue Registrierungsanfrage",
  "👥 Novo chatter registrado": "👥 Neuer Chatter registriert",
  "🎯 Novo recruiter registrado": "🎯 Neuer Recruiter registriert",
  "💰 Nova venda registrada": "💰 Neuer Verkauf registriert",
  "⚠️ Solicitação de exclusão": "⚠️ Löschungsanfrage",
  "📸 Conteúdo extra enviado": "📸 Zusätzlicher Inhalt gesendet",
  "🔗 Chatter conectado": "🔗 Chatter verbunden",
  "📄 Documentos para aprovação": "📄 Dokumente zur Genehmigung",
  "⭐ Level Up!": "⭐ Level Up!",
  "❌ Verificação falhou": "❌ Verifizierung fehlgeschlagen",
  "✅ Documentos aprovados!": "✅ Dokumente genehmigt!",
  "❌ Documentos rejeitados": "❌ Dokumente abgelehnt",
  "📸 Conteúdo exclusivo – reclamação": "📸 Exklusiver Inhalt – Beschwerde",
  "✅ Conteúdo exclusivo aprovado": "✅ Exklusiver Inhalt genehmigt",
  "❌ Conteúdo exclusivo rejeitado": "❌ Exklusiver Inhalt abgelehnt",
};

// Common message fragments PT → DE
const messagePatterns: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^Seu contrato foi assinado por ambas as partes.*$/, () => "Ihr Vertrag wurde von beiden Parteien unterschrieben! Der nächste Pipeline-Schritt ist freigeschaltet."],
  [/^Pierre \(Admin\) assinou o contrato de (.+)\. O contrato está completo\.$/, (m) => `Pierre (Admin) hat den Vertrag von ${m[1]} unterschrieben. Der Vertrag ist abgeschlossen.`],
  [/^Seu contrato está pronto.*$/, () => "Ihr Vertrag ist zur Unterschrift bereit. Bitte überprüfen und unterschreiben Sie ihn."],
  [/^Seu contrato foi aprovado.*$/, () => "Ihr Vertrag wurde genehmigt! Der nächste Schritt ist freigeschaltet."],
  [/^Suas contas.*configuradas.*$/, () => "Ihre Konten wurden konfiguriert! Bitte überprüfen Sie Ihre Zugangsdaten."],
  [/^Suas postagens.*ativadas.*$/, () => "Ihre Beiträge wurden aktiviert!"],
  [/^Você realizou sua primeira venda.*$/, () => "Sie haben Ihren ersten Verkauf getätigt! Das ist ein großartiger Meilenstein. Weiter so!"],
  [/^(.+) enviou uma mensagem para você.*$/, (m) => `${m[1]} hat Ihnen eine Nachricht gesendet. Öffnen Sie den Chat, um sie zu lesen.`],
  [/^A agência solicitou um novo conteúdo: "(.+)"$/, (m) => `Die Agentur hat neuen Inhalt angefordert: "${m[1]}"`],
  [/^Um (chatter|funcionário) criou um pedido de conteúdo exclusivo.*$/, (m) => `Ein ${m[1] === 'chatter' ? 'Chatter' : 'Mitarbeiter'} hat eine exklusive Inhaltsanfrage erstellt, die Ihre Genehmigung benötigt.`],
  [/^(.+) confirmou a entrega do conteúdo exclusivo.*$/, (m) => `${m[1]} hat die Lieferung des exklusiven Inhalts bestätigt.`],
  [/^Faltam (\d+) dias para o prazo.*$/, (m) => `Noch ${m[1]} Tage bis zur Abgabefrist für Ihre Inhalte.`],
  [/^Du hast eine neue Aufgabe: "(.+)"$/, (m) => `Du hast eine neue Aufgabe: "${m[1]}"`],
  [/^Novo chatter registrado: (.+)$/, (m) => `Neuer Chatter registriert: ${m[1]}`],
  [/^Novo recruiter registrado: (.+)$/, (m) => `Neuer Recruiter registriert: ${m[1]}`],
];

export function translateNotificationTitle(title: string, language: string): string {
  if (language !== "de") return title;
  return titleMap[title] || title;
}

export function translateNotificationMessage(message: string, language: string): string {
  if (language !== "de") return message;
  for (const [pattern, replacer] of messagePatterns) {
    const match = message.match(pattern);
    if (match) return replacer(match);
  }
  return message;
}
